import { useTranslation } from 'react-i18next';



const ErrorPage = () => {
	const { t } = useTranslation('global');

	return (
		<div className="lfmt-error error-page">
			
			<h1>{t('errorHeader')}</h1>

			<p>{t('errorMessage')}</p>

		</div>
	);
};

export default ErrorPage;